<template>
    <div class="flex-box nopadding">
        <div style="width: 80px">
            <Select :value="datearea_id" @on-change="onDteareaChange">
                <Option :value="index" v-for="(item,index) in datearea" :key="index">{{item.text}}</Option>
            </Select>
        </div>
        <DatePicker split-panels :editable="false" class="date-box"
                :value="select_date" type="daterange"
                placement="bottom-start" :placeholder="date_desc"
                @on-change="onDateChange">
        </DatePicker>
    </div>
</template>

<script>
    export default {
        name: "myDatePicker",
        model:{ //通过v-model传过来的参数
            prop: 'datearea_id',
            event: 'emitDateareaId'
        },
        props:{
            date_desc: {
                default: "",
                type: String
            },
            datearea_id:{
                default: 0,
                type: Number
            }
        },
        data:function(){
            return{
                select_date:[],
                datearea: this.$base.getDateArea()
            }
        },
        mounted: function(){
            if(this.datearea_id > 0){
                var item = this.datearea[this.datearea_id];
                this.select_date = [item.date_fr, item.date_to];
            }
        },
        methods: {
            onDteareaChange:function(index){
                this.$emit('emitDateareaId', index);
                if(index > 0) {
                    var item = this.datearea[index];
                    this.select_date = [item.date_fr, item.date_to];
                    this.$emit('onChange', this.select_date);
                }
            },
            onDateChange:function (value) {
                this.$emit('emitDateareaId', 0);
                this.$emit('onChange', value);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myDatePicker.vue